export default {"src":"/_next/static/media/box.7bc8f56b.svg","height":88,"width":88,"blurWidth":0,"blurHeight":0};